class RRSlideshowMedia extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    this.carousel = this.closest('slideshow-carousel');
    this.videos = [...this.carousel.querySelectorAll('video-media[autoplay][type="video"] video')];
    this.visible = new Set();
    this.suspended = new Set();
    const options = { signal: this.abort.signal };
    this.observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRect.width && entry.intersectionRect.height) this.visible.add(entry.target);
        else this.visible.delete(entry.target);
      }
      this.update();
    });
    for (const video of this.videos) {
      this.observer.observe(video);
      video.addEventListener('play', () => this.update(), options);
    }
    for (const event of ['carousel:change', 'carousel:settle']) this.carousel.addEventListener(event, () => this.update(), options);
    document.addEventListener('visibilitychange', () => this.update(), options);
    window.addEventListener('pagehide', () => this.suspend(), options);
    window.addEventListener('pageshow', () => this.update(), options);
  }

  update() {
    for (const video of this.videos) {
      const active = !document.hidden && this.visible.has(video) && video.closest('.slideshow__slide')?.classList.contains('is-selected');
      if (!active) {
        if (!video.paused) {
          this.suspended.add(video);
          video.pause();
        }
      } else if (this.suspended.delete(video)) {
        video.play().catch(() => {});
      }
    }
  }

  suspend() {
    for (const video of this.videos) {
      if (!video.paused) {
        this.suspended.add(video);
        video.pause();
      }
    }
  }

  disconnectedCallback() {
    this.suspend();
    this.abort?.abort();
    this.abort = null;
    this.observer?.disconnect();
  }
}

if (!customElements.get('rr-slideshow-media')) customElements.define('rr-slideshow-media', RRSlideshowMedia);
